import React from 'react';
// import PropTypes from 'prop-types';

import {Routes, Route, Navigate} from 'react-router';

import MagicLinkRedirect from './magic-link/MagicLinkRedirect';
import CaregiverScreener from './caregiver_screening/CaregiverScreener';
import CaregiverApplicationLanding from './caregiver_screening/CaregiverApplicationLanding';
import CaregiverInterview from './caregiver_interview/CaregiverInterview';

import Profile from './caregiver/CaregiverProfile';

const Router = () => {
  return (
    <Routes>
      <Route path="/signout" element={<Navigate to="/" />} />

      <Route path="/caregiver-application" element={<CaregiverInterview />} />

      <Route path="/caregiver-onboarding" element={<CaregiverApplicationLanding />} />
      <Route path='/caregiver-onboarding/form' element={<CaregiverScreener />} />

      <Route path="/magic-link" element={<MagicLinkRedirect />} />

      <Route path='/caregivers/:caregiverRn' element={<Profile />} />

      <Route path="*" element={<CaregiverInterview />} />
    </Routes>
  );
};

Router.propTypes = {
};

export default React.memo(Router);

